import React, { memo } from 'react';
import DSAgentWrapper, { ISelectedDsModelType } from '../../../Home/components/DSAgent';
import { DSAgentModelResponse } from '../../../service/service';
import { CopilotGreeting } from '../CopilotGreeting';
import './index.scss';

interface ICopilotDSHomeRecommendationProps {
  /** 当前选中的模型 */
  currentSelectedDsModel?: ISelectedDsModelType;
  /** 设置选中模型的方法 */
  setCurrentSelectedDsModel?: React.Dispatch<React.SetStateAction<ISelectedDsModelType | undefined>>;
  /** DS Agent 数据列表（外部传入） */
  dSExpertAgent: DSAgentModelResponse['agent_models'][];
  /** 数据加载状态（外部传入） */
  loading?: boolean;
  /** 底部输入框区域高度（动态计算） */
  inputAreaHeight?: number;
}

export const CopilotDSHomeRecommendation = memo(
  ({ currentSelectedDsModel, setCurrentSelectedDsModel, dSExpertAgent, loading, inputAreaHeight }: ICopilotDSHomeRecommendationProps) => {
    return (
      <div className="dbh-agent-landing-page dba-copilot-ds-landing-page">
        <CopilotGreeting tab="dsReport" />
        <DSAgentWrapper
          variant="copilot"
          currentSelectedDsModel={currentSelectedDsModel}
          setCurrentSelectedDsModel={setCurrentSelectedDsModel}
          dSExpertAgent={dSExpertAgent}
          loading={loading}
          inputAreaHeight={inputAreaHeight}
        />
      </div>
    );
  },
);

CopilotDSHomeRecommendation.displayName = 'CopilotDSHomeRecommendation';

export default CopilotDSHomeRecommendation;
